import { render, staticRenderFns } from "./layout-product-page.vue?vue&type=template&id=2857d154&scoped=true"
import script from "./layout-product-page.vue?vue&type=script&lang=js"
export * from "./layout-product-page.vue?vue&type=script&lang=js"
import style0 from "./layout-product-page.vue?vue&type=style&index=0&id=2857d154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2857d154",
  null
  
)

export default component.exports